// extracted by mini-css-extract-plugin
module.exports = {"Container":"ObjectForm_Container__2NyYt","FieldsList":"ObjectForm_FieldsList__iDmlO","Controls":"ObjectForm_Controls__3bref"};